import styled from "styled-components";
import { Select } from "@material-ui/core";

const InputUnitsWrapper = styled(Select)`
  & div > div:first-of-type {
    // text-align: center;
    padding-top: 0px;
    padding-left: 0px;
    padding-bottom: 0px;
    padding-right: 0px;
  }
`;

export default InputUnitsWrapper;
